export default {
  getMap(options) {
    return new window.google.maps.Map(document.getElementById("map"), {
      zoom: 10,
      minZoom: 10,
      maxZoom: 14,
      center: {
        lng: -0.118092,
        lat: 51.509865
      },
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      clickableIcons: false,
      ...options
    });
  },
  getMarker(options) {
    return new window.google.maps.Marker({
      ...options
    });
  },
  getLatLng(options) {
    return new window.google.maps.LatLng({
      ...options
    });
  },
  getGeocoder(options) {
    return new window.google.maps.Geocoder({
      ...options
    });
  }
};
